import React, { createContext, useContext, useState } from 'react';

const TabsContext = createContext({ activeTab: '', setActiveTab: () => {} });

export const Tabs = ({ defaultValue, value, onValueChange, className = '', children, ...props }) => {
  const [internalTab, setInternalTab] = useState(defaultValue || '');
  const controlled = value !== undefined;
  const activeTab = controlled ? value : internalTab;
  const setActiveTab = controlled ? onValueChange : setInternalTab;

  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab }}>
      <div className={className} {...props}>{children}</div>
    </TabsContext.Provider>
  );
};

export const TabsList = React.forwardRef(({ className = '', ...props }, ref) => (
  <div ref={ref} className={`inline-flex h-10 items-center justify-center rounded-md bg-gray-100 p-1 text-gray-500 ${className}`} {...props} />
));
TabsList.displayName = 'TabsList';

export const TabsTrigger = React.forwardRef(({ className = '', value, ...props }, ref) => {
  const { activeTab, setActiveTab } = useContext(TabsContext);
  const isActive = activeTab === value;
  return (
    <button
      ref={ref}
      className={`inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all focus:outline-none disabled:pointer-events-none disabled:opacity-50 ${isActive ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-900'} ${className}`}
      onClick={() => setActiveTab(value)}
      {...props}
    />
  );
});
TabsTrigger.displayName = 'TabsTrigger';

export const TabsContent = React.forwardRef(({ className = '', value, ...props }, ref) => {
  const { activeTab } = useContext(TabsContext);
  if (activeTab !== value) {return null;}
  return <div ref={ref} className={`mt-2 focus:outline-none ${className}`} {...props} />;
});
TabsContent.displayName = 'TabsContent';
